import { PageLoading, useUserAccess } from '@ui-framework/index';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ServiceModuleProvider,
  useServiceModule,
} from '../providers/ServiceModuleProvider';

export { default as authFnAllowAdminImplementationManagerOrSASupervisor } from './authorization';

// Default authorization function for Maintenance pages
export const authFnForMaintenancePages = userAccess => {
  return userAccess.isSA() || userAccess.isAdmin();
};

export const authFnForMaintenanceCreatePages = userAccess => {
  return (
    userAccess.isSASupervisor() || userAccess.isAdminImplementationManager()
  );
};

export const authFnAllowOnlyAdmin = userAccess => {
  return userAccess.isAdmin();
};

export const authFnAllowNonReadonlySASPandAdmin = userAccess => {
  return (
    !userAccess.isUserReadonly() &&
    (userAccess.isAdmin() || userAccess.isSA() || userAccess.isSP())
  );
};

export const authFnAllowOnlyAdminImplementationManager = userAccess => {
  return userAccess.isAdminImplementationManager();
};

// Default authorization function for SA or Admin only pages
export const authFnAllowOnlySA = userAccess => {
  return userAccess.isSA() || userAccess.isAdmin();
};

// Default authorization function for SA or Admin only pages
export const authFnAllowOnlySAWithModule = (
  userAccess,
  moduleSettings,
  moduleName,
) => {
  return (
    (userAccess.isSA() || userAccess.isAdmin()) &&
    moduleSettings?.[moduleName] === true
  );
};

function AuthorizationWrapper({ children, authorizationFn = [] }) {
  const userAccess = useUserAccess();
  const [loading, setLoading] = useState(true);
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    try {
      setLoading(true);
      if (
        authorizationFn ||
        (Array.isArray(authorizationFn) && authorizationFn.length > 0)
      ) {
        const isAuthorized = authorizationFn.every(fn => fn(userAccess));
        if (isAuthorized) {
          setShowChildren(true);
        } else {
          window.location.href = '/unauthorized';
        }
      }
    } catch (e) {
      window.location.href = `/servererror?serverError=${e.message}`;
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    <PageLoading>
      <FormattedMessage id="AUTHORIZING" defaultMessage="Authorizing" />
      ...
    </PageLoading>;
  }
  if (showChildren) {
    return children;
  }

  return null;
}

function ModuleSettingsChecker({
  children,
  moduleName = null,
  authorizationFn = [],
}) {
  const { moduleSettings } = useServiceModule();
  const userAccess = useUserAccess();
  const [loading, setLoading] = useState(true);
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    try {
      setLoading(true);
      if (
        authorizationFn ||
        (Array.isArray(authorizationFn) && authorizationFn.length > 0)
      ) {
        const isAuthorized = authorizationFn.every(fn =>
          fn(userAccess, moduleSettings, moduleName),
        );
        if (isAuthorized) {
          setShowChildren(true);
        } else {
          window.location.href = '/unauthorized';
        }
      }
    } catch (e) {
      window.location.href = `/servererror?serverError=${e.message}`;
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    <PageLoading>
      <FormattedMessage id="AUTHORIZING" defaultMessage="Authorizing" />
      ...
    </PageLoading>;
  }
  if (showChildren) {
    return children;
  }

  return null;
}

export function ModuleSettingsAuthorizationWrapper({
  children,
  moduleName = null,
  authorizationFn = [],
}) {
  if (!moduleName) {
    throw new Error(
      'Please add moduleName name for AuthorizationWrapperProps in your modules index file',
    );
  }

  return (
    <ServiceModuleProvider>
      <ModuleSettingsChecker
        moduleName={moduleName}
        authorizationFn={authorizationFn}>
        {children}
      </ModuleSettingsChecker>
    </ServiceModuleProvider>
  );
}
export default AuthorizationWrapper;
